import { MESApiService } from "@dexteel/mesf-core";

export const getLadles = async () => {
  const apiService = new MESApiService();
  return await apiService.callV2("[STEEL].[GetLadles]", []);
};
